import Backbone from 'backbone';
import StateDropdown from './StateDropdown';
import States from '../model/States';
import State from '../model/State';
import config from '../config/config';

export default Backbone.View.extend({
  initialize(o) {
    this.em = o.em;
    this.GConfig = o.GConfig;
    this.config = config;
    this.statesCollection = new States(this.config.states);
    this.stateDropdown = new StateDropdown({
      collection: this.statesCollection,
      em: o.em,
      GConfig: o.GConfig
    });
    this.em.on('component:selected', this.blockChanged.bind(this));
  },

  events: {
    'click .heading': 'openState',
    'click .add_state .right-btn': 'addState',
    'focusout .block_name input': 'setBlockName'
  },

  blockChanged(model) {
    //set block name
    var blockName = model.get('blockName');
    if (blockName) {
      this.enableState();
      this.$el.find('.block_name input').val(blockName);
    } else {
      this.disableState();
      this.$el.find('.block_name input').val('');
    }

    // set states
    var states = this.em.getSelected().get('statesCollection');
    if (states) {
      this.statesCollection.reset(states);
    } else {
      this.statesCollection.reset(this.config.states);
      this.em
        .getSelected()
        .set('statesCollection', this.statesCollection.toJSON());
    }
    this.stateDropdown.render();
  },

  disableState() {
    this.$el.find('.state_selector').addClass('disabled');
    this.$el.find('.add_state').addClass('disabled');
  },

  enableState() {
    this.$el.find('.state_selector').removeClass('disabled');
    this.$el.find('.add_state').removeClass('disabled');
  },

  openState(e) {
    let $icon = this.$el.find('.heading i');
    if ($icon.hasClass('fa-caret-right')) {
      $icon.attr('class', 'fa fa-caret-down');
      this.$el.find('.state_wrapper').removeClass('hide');
    } else {
      $icon.attr('class', 'fa fa-caret-right');
      this.$el.find('.state_wrapper').addClass('hide');
    }
  },

  addState(e) {
    var $stateInput = this.$el.find('.add_state input');
    var stateName = $stateInput.val();
    if (stateName) {
      console.log(stateName);
      var unique = stateName.replace(/ /g, '_').trim();
      var obj = {
        id: unique,
        name: stateName,
        className: 'dhq_state_' + unique
      };
      this.statesCollection.add(obj);
      this.em
        .getSelected()
        .set('statesCollection', this.statesCollection.toJSON());
      this.stateDropdown.render();
      $stateInput.val('');
    }
  },

  setBlockName(e) {
    var blockName = e.target.value;
    this.em.getSelected().set('blockName', blockName);
    blockName ? this.enableState() : this.disableState();
  },

  template() {
    return `<div class="heading" data-sector-title="">
              <i class="fa fa-caret-right"></i>States
            </div>
            <div class="state_wrapper hide">
                <div class="block_name labled_input">
                    <div class="label">Block name <div data-popup_doc_id="State Block Name" class="info-plugin-div"><img src="${this.GConfig.rootDir}/assets/icons/info.svg"></div></div>
                    <div class="input-wrp"><input type="text"></div>
                </div>
                <div class="labled_input">
                  <div class="label">Select state <div data-popup_doc_id="State Name" class="info-plugin-div"><img src="${this.GConfig.rootDir}/assets/icons/info.svg"></div></div>
                  <div class="state_selector">
                  </div>
                </div>
            </div > `;
  },

  render() {
    this.$el.empty();
    this.$el.addClass('gjs-stm-sector gjs-one-bg gjs-two-color');
    this.$el.append(this.template());
    this.$el.find('.state_selector').append(this.stateDropdown.render().$el);
    return this;
  }
});
